(ns dre.panels.db
  (:require
   [dre.panels.refine-search.views :as refine-search]
   [dre.panels.author.views :as author]
   [dre.panels.author.events :as e-author]
   [dre.panels.sense-detail.views :as sense-detail]
   [dre.pages.dictionary.events :as e-sense-detail]))


(def registry
  [{:id :refine-search
    :view refine-search/view}
   {:id :author
    :view author/view
    :init-fx ::e-author/init}
   {:id :sense-detail
    :view sense-detail/view
    :init-fx ::e-sense-detail/init}])


(def index (into {} (map (juxt :id identity)) registry))
